export default "/images/framework/Badge_02.52dcc19d.svg?52dcc19d";